import type { CopilotBlockingNotice } from "@/features/copilot/lib/copilot-action-blocking";
import { copilotActionTitleId } from "@/features/copilot/lib/copilot-action-display";

/// Explains why the input is locked. The card may have scrolled out of view, so a pending decision
/// carries a way back to it.
export function CopilotBlockingNoticeLine({ notice }: { notice: CopilotBlockingNotice }) {
  if (!notice) return null;

  function review(toolCallId: string) {
    const heading = document.getElementById(copilotActionTitleId(toolCallId));
    heading?.scrollIntoView({ block: "center" });
    heading?.focus();
  }

  return (
    <p role="status" className="mb-2 flex items-center gap-2 text-xs text-text-secondary">
      {notice.kind === "decide" ? (
        <>
          Confirm or decline the change above to keep chatting.
          <button
            type="button"
            onClick={() => review(notice.toolCallId)}
            className="rounded text-primary hover:underline focus-visible:outline-2 focus-visible:outline-ring"
          >
            Review
          </button>
        </>
      ) : (
        "Waiting for the change above to finish."
      )}
    </p>
  );
}
